module.exports = "pegasus/assets/theme2/twitter.png";